import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import ConfirmAccountForm from './ConfirmAccountForm';
import history from '../../history';
import axios from '../../lib/axiosInstance';

class ConfirmAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      loginscreen: [],
      loginmessage: '',
      buttonLabel: 'Register',
      isLogin: true,
      is_authenticated: false,
      openNotificationModal: false,
      modalTitle: '',
      modalTitleFailure: '',
      modalDetail: '',
      modalDetailFailure: '',
      verifyDevice: false,
      remember_me: false,
    };
  }
  renderNotification() {
    // const [open, setOpen] = React.useState(true);
    return (
      <>
        {/* <Collapse in={this.state.openNotificationModal === true}>
                <Alert severity={this.state.is_authenticated === true ? "success" : "error"} action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                            this.setState({ openNotificationModal: false });
                        }}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }>
                    <AlertTitle>{this.state.is_authenticated === true ? this.state.modalTitle : this.state.modalTitleFailure}</AlertTitle>
                    {this.state.is_authenticated === true ? this.state.modalDetail : this.state.modalDetailFailure}
                </Alert>
            </Collapse> */}
        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }
  async loginUser() {
    // //console.log("Hello Parental World")
    // let accessToken = ''
    if (this.state.password) {
      let data = {
          password: this.state.password,
          confirm_password: this.state.confirm_password,
        },
        url =
          '/profiles/confirm-account/' + this.props.match.params.confirmToken;
      await axios
        .put(url, data)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            // this.setState({
            //     is_authenticated: true,
            //     openNotificationModal: true,
            //     modalDetail: res.data.success,
            //     modalTitle: 'Success!'
            // })
            toast('Success! ' + res.data.success, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
            setTimeout(function () {
              history.push('/login');
            }, 100);
          } else {
            // this.setState({
            //     is_authenticated: false,
            //     openNotificationModal: true,
            //     modalDetailFailure: res.data.detail,
            //     modalTitleFailure: 'Authentication Failed!'
            // })
            toast.error('Authentication Failed! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((err) => {
          let res = err.response;
          if (res.status === 422) {
            localStorage.removeItem('refresh');
            localStorage.removeItem('access');
            localStorage.removeItem('refreshTokenSetAt');
            localStorage.removeItem('accessTokenSetAt');
            // this.setState({
            //     is_authenticated: false,
            //     openNotificationModal: true,
            //     modalDetailFailure: res.data.detail,
            //     modalTitleFailure: 'Authentication Failed!'
            // })
            toast.error('Authentication Failed! ' + res.data.detail, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (res.status === 200) {
            // this.setState({
            //     is_authenticated: false,
            //     openNotificationModal: true,
            //     modalDetailFailure: res.data,
            //     modalTitleFailure: 'Authentication Failed!'
            // })
            toast.error('Authentication Failed! ' + res.data, {
              position: 'bottom-right',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
      // await setDeviceInfo(accessToken, this.state.remember_me);
      let self = this;
      setTimeout(function () {
        self.setState({ verifyDevice: true });
      }, 60);
    }
  }
  setValue(key, value) {
    if (key) {
      if (key === 'remember_me') {
        let remember_me = this.state.remember_me;
        this.setState({ remember_me: !remember_me });
      } else {
        this.setState({ [key]: value });
      }
      // //console.log('stateObject', value)
    }
  }
  componentWillMount() {
    // let loginscreen = [],
    //     verifyOTPScreen = [];
    // refreshAccessToken();
    // let verified_at = localStorage.getItem('verified_at')
    // let accessToken = localStorage.getItem('access')
    // // if (accessToken && accessToken.length > 0 && verified_at && (verified_at !== undefined && verified_at !== 'undefined')) {
    // //     //console.log('accessToken', accessToken)
    // //     history.push('/' + atob(localStorage.getItem(btoa('approle'))) + '/dashboard')
    // // }
    // loginscreen.push(<Login parentContext={this} loginUser={this.loginUser.bind(this)} setValue={this.setValue.bind(this)}
    //     appContext={this.props.parentContext} />);
    // verifyOTPScreen.push(<VerifyOTP parentContext={this} loginUser={this.loginUser.bind(this)} setValue={this.setValue.bind(this)}
    //     appContext={this.props.parentContext} verifyOTP={this.verifyOTP.bind(this)} />)
    // var loginmessage = "Not registered yet, Register Now";
    // this.setState({
    //     loginscreen: loginscreen,
    //     verifyOTPScreen: verifyOTPScreen,
    //     loginmessage: loginmessage
    // })
  }
  componentDidMount() {
    let device_uid = localStorage.getItem('device_uid');
    if (device_uid === undefined || device_uid === '' || device_uid === null) {
      var dateObject = new Date();
      device_uid =
        dateObject.getFullYear() +
        '' +
        dateObject.getMonth() +
        '' +
        dateObject.getDate() +
        '' +
        dateObject.getTime();
      localStorage.setItem('device_uid', device_uid);
    }
    //console.log('device_uid', device_uid)
  }
  screen() {
    if (this.state.verifyDevice === true) {
      return this.state.verifyOTPScreen;
    } else {
      return this.state.loginscreen;
    }
  }
  render() {
    return (
      <>
        <div className="loginscreen">
          <ConfirmAccountForm
            parentContext={this}
            loginUser={this.loginUser.bind(this)}
            setValue={this.setValue.bind(this)}
            appContext={this.props.parentContext}
          />
        </div>
        {this.renderNotification()}
      </>
    );
  }
}
// const style = {
//     margin: 15,
// };
export default ConfirmAccount;
